import './config/public-path';
import { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import '@/lib/i18n';
import lazySizes from 'lazysizes';

import { mobx } from '@/lib/mobx';
import { ensureSpriteInjected } from '@/helpers/additionalScripts/spriteInjector';
// @ts-expect-error
import iconsUrl from '~/public/assets/images/sprites/sprite-icons.svg';

const App = lazy(() => import('./app/App').then((module) => ({ default: module.App })));

import { Logger, logger } from '@/lib/api/logger';
import { initPostMessage } from '@/lib/api/postMessageAPI';
import { eventListenersHandler } from '@/helpers/eventListenersHandler';
import { importGoogleFont } from '@/helpers/importGoogleFont';
import { isShadowMode } from '@/config';
import { defaultFontURL } from '@/config/constants';

import { Socket } from './lib/api/Socket';

lazySizes.init();

// Logger.init();

declare global {
  interface Window {
    Sportsbook?: {
      destroy: () => void;
    };
  }
}

// A global object is created that includes events with their listeners and handlers.
eventListenersHandler();

let rootElement = document.getElementById('sportsbook-app') as HTMLElement | ShadowRoot;

if (isShadowMode) {
  rootElement = rootElement?.attachShadow({ mode: 'open' });
  mobx.ui.setAppRoot(rootElement);
  importGoogleFont({ googleFontUrl: defaultFontURL, isInstallFont: true }).catch((error) => {
    logger.error('Error loading default font:', error);
  });
  ensureSpriteInjected(rootElement, iconsUrl).catch(console.error);
} else {
  ensureSpriteInjected(document, iconsUrl).catch(console.error);
}

initPostMessage();

try {
  const root = createRoot(rootElement);
  root.render(
    <Suspense fallback={null}>
      <App />
    </Suspense>,
  );
} catch (error) {
  console.error('Error during Sportsbook App rendering:', error);
  if (window.Sportsbook) {
    window.Sportsbook?.destroy();
    Socket.closeSocket();
  }
}

// if (process.env.NODE_ENV === 'development') {
//   import('react-scan').then(({ scan }) => {
//     scan({
//       enabled: false,
//       trackUnnecessaryRenders: true,
//       animationSpeed: 'off',
//       showToolbar: process.env.NODE_ENV === 'development',
//       showNotificationCount: true,
//       showFPS: true,
//     });
//   });
// }
